export default "__VITE_ASSET__B2nDAQ09__"